import {ACTIONS} from './constants';
import type {Action} from './actions';

export type State = {
	disabled: boolean;
	activeIndex: number;
	active: boolean;
	interactingWithItem: boolean;
	total: number;
	pageSize: number;
};

export const initialState: State = {
	disabled: false,
	activeIndex: 0,
	active: false,
	interactingWithItem: false,
	pageSize: 25,
	total: 0,
};

const checkIndexLoop = (index: number, total: number) =>
	index > total - 1 ? 0 : index < 0 ? total - 1 : index;

const keepInBounds = (index: number, total: number) =>
	Math.max(Math.min(index, total - 1), 0);

export const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case ACTIONS.DISABLE:
			return {
				...state,
				disabled: true,
			};
		case ACTIONS.ENABLE:
			return {
				...state,
				disabled: false,
			};
		case ACTIONS.END:
			return {
				...state,
				activeIndex: keepInBounds(state.total - 1, state.total),
			};
		case ACTIONS.HOME:
			return {
				...state,
				activeIndex: 0,
			};
		case ACTIONS.NEXT_ITEM:
			return {
				...state,
				activeIndex: checkIndexLoop(state.activeIndex + 1, state.total),
			};
		case ACTIONS.NEXT_PAGE:
			return {
				...state,
				activeIndex: keepInBounds(
					state.activeIndex + state.pageSize,
					state.total,
				),
			};
		case ACTIONS.PREV_ITEM:
			return {
				...state,
				activeIndex: checkIndexLoop(state.activeIndex - 1, state.total),
			};
		case ACTIONS.PREV_PAGE:
			return {
				...state,
				activeIndex: keepInBounds(
					state.activeIndex - state.pageSize,
					state.total,
				),
			};
		case ACTIONS.SET_ACTIVE:
			return {
				...state,
				active: action.active,
			};
		case ACTIONS.SET_ACTIVE_ITEM:
			return {
				...state,
				activeIndex: keepInBounds(action.activeIndex, state.total),
			};
		case ACTIONS.SET_INTERACTING_WITH_ITEM:
			return {
				...state,
				interactingWithItem: action.interactingWithItem,
			};
		case ACTIONS.SET_TOTAL:
			return {
				...state,
				total: action.total,
				interactingWithItem: false,
				activeIndex: keepInBounds(state.activeIndex, action.total),
			};
		case ACTIONS.SET_PAGE_SIZE:
			return {
				...state,
				pageSize: action.pageSize || initialState.pageSize,
			};
	}
};

export default reducer;
